module.exports = __webpack_public_path__ + "static/media/ic_config.0c989c09.svg";